module.exports = __webpack_public_path__ + "media/images/icons/globe-1a6889df04e64e45cc47a6b761711df7.svg";